import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-icon-crossOut-active",
  "use": "svg-icon-crossOut-active-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"svg-icon-crossOut-active\"><g fill-rule=\"nonzero\" stroke=\"#F15F4B\" stroke-width=\"2\" fill=\"none\"><circle cx=\"10.025\" cy=\"9.474\" r=\"8.474\" /><path d=\"M5.263 4.737l9.79 9.782\" stroke-linecap=\"square\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol